module.exports = require('./lib/index.js')



//////////////////
// WEBPACK FOOTER
// ./~/ethereumjs-abi/index.js
// module id = 1167
// module chunks = 0